import axios from "axios";
import { baseurl } from "domain";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Icon from "@mui/material/Icon";
import team2 from "assets/images/team-2.jpg";
import { useState } from "react";
import { Typography } from "@mui/material";

// Define Author component
const Author = ({ image, name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDAvatar src={image} name={name} size="sm" />
    <MDBox ml={2} lineHeight={1}>
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="button">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

Author.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

const convertTo12Hour = (time24) => {
  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};

// Define Job component
const Job = ({ title, description }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
      {title}
    </MDTypography>
    <MDTypography variant="caption">{description}</MDTypography>
  </MDBox>
);

Job.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Job.defaultProps = {
  description: "",
};

async function authorsTableData(filters, handleClickView, handleClickDelete, handleEditClick, setLoading) {
  let data = [];

  // ✅ Start loading
  if (setLoading) setLoading(true);

  try {
    const response = await axios.post(`https://${baseurl}/filterPCHBookings`, filters);
    data = response.data.pch_bookings;
  } catch (error) {
    console.error("Error fetching filtered data:", error);
  }

  // ✅ Stop loading
  if (setLoading) setLoading(false);

  var columns = [
    { Header: "Name", accessor: "Name", width: "20%", align: "left" },
    { Header: "Date", accessor: "Date", align: "center" },
    { Header: "Type", accessor: "Type", align: "center" },
    { Header: "Method", accessor: "Method", align: "center" },
    { Header: "Timestamp", accessor: "Timestamp", align: "center" },
    { Header: "Edit", accessor: "Edit", align: "center" },
    { Header: "View", accessor: "View", align: "center" },
  ];

  const rows = data.map((user) => ({
    Name: <Typography fontSize={"large"}><b>{user.name}</b></Typography>, 
    Phone: <Typography fontSize={"large"}>{user.phnNo}</Typography>,
    Date: <Typography fontSize={"large"}>{user.date}</Typography>,
    Type: <Typography fontSize={"large"}>{user.subCatType}</Typography>,
    Method: <Typography fontSize={"large"}>{user.bookedBy} - {user.a_name}</Typography>,
    Timestamp: <Typography fontSize={"large"}>{user.timestamp}</Typography>,
    View: (
      <MDButton
        variant="text"
        color="primary"
        style={{ color: "blue" }}
        onClick={() => handleClickView(user.payment_id)}
      >
        <VisibilityIcon style={{ color: "blue" }} />
        &nbsp;view
      </MDButton>
    ),
    Delete: (
      <MDButton variant="text" color="error" onClick={() => handleClickDelete(user.uid)}>
        <Icon>delete</Icon>&nbsp;delete
      </MDButton>
    ),
    Edit: (
      <MDButton variant="text" color="dark" onClick={() => handleEditClick(user.payment_id)}>
        <Icon>edit</Icon>&nbsp;edit
      </MDButton>
    ),
  }));

  return { columns, rows };
}


export default authorsTableData;
